/* eslint-disable react/prop-types */
import ArgonTypography from "components/ArgonTypography";

const activityAttendanceTableData4 = (leaveEntries = []) => {
  const rows = (Array.isArray(leaveEntries) ? leaveEntries : []).map((entry, index) => {
    const addedOn = entry?.addedOn ? new Date(entry.addedOn) : null;
    const leaveDate = entry?.date ? new Date(entry.date) : null;
    const addedOnLabel =
      addedOn && !Number.isNaN(addedOn.getTime()) ? addedOn.toLocaleDateString("en-GB") : "NA";
    const leaveDateLabel =
      leaveDate && !Number.isNaN(leaveDate.getTime())
        ? leaveDate.toLocaleDateString("en-GB")
        : "NA";

    return {
      "S.No.": (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          {index + 1}
        </ArgonTypography>
      ),
      "Added on": (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          {addedOnLabel}
        </ArgonTypography>
      ),
      Date: (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          {leaveDateLabel}
        </ArgonTypography>
      ),
      "Leave By": (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          {entry?.message || "NA"}
        </ArgonTypography>
      ),
    };
  });

  return {
    columns: activityAttendanceTableData4.columns,
    rows,
  };
};

activityAttendanceTableData4.columns = [
  { name: "S.No.", align: "center" },
  // { name: "Added on", align: "center" },
  { name: "Date", align: "center" },
  { name: "Leave By", align: "center" },
];

activityAttendanceTableData4.rows = [];

export default activityAttendanceTableData4;
